<div class="app-page">
	<left-panel [@openCloseLeftPanel]="hideLeftPanel || DataStorageHelper.isPortal() ? 'closed' : 'open'"></left-panel>

	<div
		class="delimiter-1 hide"
		[class.is-portal]="DataStorageHelper.isPortal()"
		[@openCloseDelimiter]="hideLeftPanel || DataStorageHelper.isPortal() ? 'closed' : 'open'"
	>
		<div class="left-panel-toggle" (click)="toggleLeftPanel.emit()">
			<amc-iconify icon="chevron-left" size="l" *ngIf="!hideLeftPanel"></amc-iconify>
			<amc-iconify icon="chevron-right" size="l" *ngIf="hideLeftPanel"></amc-iconify>
		</div>
	</div>
	<div class="delimiter-2 hide" *ngIf="!DataStorageHelper.isPortal()"></div>

	<div class="right-panel" [@openCloseRightPanel]="hideLeftPanel || DataStorageHelper.isPortal() ? 'closed' : 'open'">
		<mdm-header class="header"><router-outlet name="filters"></router-outlet></mdm-header>
		<div class="content"><router-outlet></router-outlet></div>
	</div>
</div>
